import { Status } from '../enums/Status';

export const statusIcons: Record<string, string> = {
  [Status.ACTIVE]: 'bg-green-500',
  [Status.INACTIVE]: 'bg-red-500',
};
